import type { ReactNode } from 'react'

import { useRouter } from 'next/router'
import { RefreshCw, ServerCrash } from 'lucide-react'

interface UnavailableProps {
    message?: string | null
}

const Unavailable = ({ message }: UnavailableProps): ReactNode => {
    const router = useRouter()

    return (
        <div className='mx-auto flex max-w-lg flex-col items-center rounded-xl border border-border bg-card px-6 py-14 text-center'>
            <span className='flex size-11 items-center justify-center rounded-full bg-secondary text-muted-foreground'>
                <ServerCrash aria-hidden='true' className='size-5' />
            </span>

            <h1 className='mt-5 font-heading text-lg font-semibold'>Market data is catching up</h1>

            <p className='mt-2 text-sm leading-relaxed text-muted-foreground'>
                {message ?? 'Market data is temporarily unavailable. Please try again in a moment.'}
            </p>

            <button
                type='button'
                onClick={() => router.replace(router.asPath)}
                className='mt-6 inline-flex h-9 items-center gap-2 rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90'
            >
                <RefreshCw aria-hidden='true' className='size-4' />
                Try again
            </button>
        </div>
    )
}

export default Unavailable
